var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 5C2.25 3.48122 3.48122 2.25 5 2.25H8.27924C9.03249 2.25 9.70124 2.732 9.93944 3.4466L11.4372 7.94004C11.7126 8.76624 11.3386 9.66921 10.5597 10.0587L8.96962 10.8537C9.92192 12.6215 11.3785 14.0781 13.1463 15.0304L13.9413 13.4403C14.3308 12.6614 15.2338 12.2874 16.06 12.5628L20.5534 14.0606C21.268 14.2988 21.75 14.9675 21.75 15.7208V19C21.75 20.5188 20.5188 21.75 19 21.75H18C9.30152 21.75 2.25 14.6985 2.25 6V5ZM5 3.75C4.30964 3.75 3.75 4.30964 3.75 5V6C3.75 13.8701 10.1299 20.25 18 20.25H19C19.6904 20.25 20.25 19.6904 20.25 19V15.7208C20.25 15.6132 20.1811 15.5176 20.0791 15.4836L15.5856 13.9858C15.4676 13.9464 15.3386 13.9999 15.283 14.1111L14.1543 16.3684C13.9743 16.7284 13.5422 16.8822 13.1752 16.7167C10.5638 15.5393 8.46071 13.4362 7.28329 10.8248C7.11784 10.4578 7.27157 10.0257 7.6316 9.84568L9.88886 8.71705C10.0001 8.66141 10.0536 8.53241 10.0142 8.41438L8.51641 3.92094C8.48238 3.81886 8.38685 3.75 8.27924 3.75H5Z",
    fill: "#363030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.7a6d7530db43d658f2da4b4f690c60d1.svg";
export { ForwardRef as ReactComponent };